// Device detection for the PWA install prompt. These read the platform, not the
// viewport — use Tailwind responsive prefixes for layout (see
// standards/frontend/mobile-app-detection.md).

// True on any iOS / iPadOS device, regardless of browser. iOS cannot fire
// `beforeinstallprompt` or be prompted programmatically, so every iOS browser
// (Safari, Chrome, Firefox, Edge — all WebKit, all with the share sheet) gets the
// manual "Share → Add to Home Screen" hint. iPadOS Safari reports a macOS UA, so
// a touch-capable "Macintosh" counts as iOS too.
export function isIos(): boolean {
  const ua = window.navigator.userAgent
  if (/iphone|ipad|ipod/i.test(ua)) {
    return true
  }
  return /Macintosh/i.test(ua) && window.navigator.maxTouchPoints > 1
}

// True on a touch-first (mobile) device. Used to offer the manual install hint on
// Android browsers that never fire `beforeinstallprompt`, while never nagging a
// desktop user who has no home-screen to install onto.
export function isTouchDevice(): boolean {
  return window.matchMedia("(pointer: coarse)").matches
}
